import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import {ThemeProvider} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import App from "./App";
import theme from "./styles/theme";
import {ToastProvider} from "./context/toast";
import "./styles/index.css";
import "./i18n";

const queryClient = new QueryClient({
    defaultOptions: {queries: {refetchOnWindowFocus: false}},
});

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
    <StrictMode>
        <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={theme}>
                <CssBaseline/>
                <ToastProvider>
                    <App/>
                </ToastProvider>
            </ThemeProvider>
        </QueryClientProvider>
    </StrictMode>,
);
